module.exports = __webpack_public_path__ + "static/hero-editted-dd9f8ff0fa02fd9a0f109607796e3b90.png";